/**
 * Returns an array containing only the distinct values from the input array.
 *
 * @param {any[]} array - The input array.
 * @returns {any[]} - An array with distinct values.
 */
export function distinctValues(array: any[]): any[] {
    return array.reduce((previous: string[], current: any) => {
        if (!previous.includes(current)) {
            return [...previous, current];
        } else {
            return previous;
        }
    }, []);
}

/** Compare (nested) arrays of primitive types
 * @param {any[]} A First array.
 * @param {any[]} B Second array.
 * @returns {boolean} True if arrays are equal, otherwise false.
 */
export function compareArrays(A: any[], B: any[]): boolean {
    // if the A array is a falsy value, return
    if (!A) return false;
    // if the B array is a falsy value, return
    if (!B) return false;
    // if the argument is the same array, we can be sure the contents are same as well
    if (A === B) return true;
    // compare lengths - can save a lot of time
    if (A.length != B.length) return false;

    for (var i = 0, l = A.length; i < l; i++) {
        // Check if we have nested arrays
        if (A[i] instanceof Array && B[i] instanceof Array) {
            // recurse into the nested arrays
            if (!compareArrays(A[i], B[i])) return false;
        } else if (A[i] != B[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}

/**
 * Convert a value to an array.
 * @param value any value.
 * @returns Array.
 */
export default function toArray(value: any): any[] {
    if (value === null || value === undefined) {
        return [];
    }

    if (Array.isArray(value)) {
        return value;
    }

    if (typeof value === 'string') {
        return [value];
    }

    if (typeof value[Symbol.iterator] === 'function') {
        return [...value];
    }

    return [value];
}

/**
 * Checks if A is subset of B.
 *
 * @param {Array} A - The array to check for inclusion.
 * @param {Array} B - The array to check against.
 * @returns {boolean} Returns true if all elements of A are found in B, false otherwise.
 */
export function areElementsIncluded(A: any[], B: any[]): boolean {
    const notIncluded = A.filter(
        (x) => !B.includes(x)
    );
    // if notIncluded is empty, then all elements of _all are included in _in
    return notIncluded.length === 0;
}